import { Outlet } from "react-router-dom";
import ResponsiveAppBarLanding from "../app-bar/app-bar-landing";
import Footer from "../footer/footer";

function LayoutLanding() {
  
  return (

      <div className="layout">
        <ResponsiveAppBarLanding />
        <div className="main-content">
          <Outlet />
        </div>
        <Footer />
      </div>
    
  );
}

export default LayoutLanding;
